import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterByValueObject'
})
export class FilterByValueObjectPipe implements PipeTransform {
  transform(items: any[], search: string): any[] {
    if (!items) return [];
    if (!search) return items;

    const searchTerm = search.toString().toLowerCase();

    return items.filter(item => {
      if (!item.valueObject) return false;

      return Object.values(item.valueObject).some((field: any) => {
        if (field?.value === null || field?.value === undefined) return false;
        return field.value.toString().toLowerCase().includes(searchTerm);
      });
    });
  }
}
